<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" *ngIf="cp" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider" fxLayout="column">
      <div class="about-cube">
        <app-profile-header [disabled]="true" [profile]="cp" [containProfileImage]="true"></app-profile-header>

        <div class="aboutme-content" fxLayout="column" fxLayoutGap="20px">
          <!-- NAVIGATION -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px">
            <ng-container *ngFor="let tabKey of tabKeys; let i = index">
              <button
                *ngIf="typeService.profileObjectFilled(displayStructure[tabKey])"
                [class.light-grey-button]="tabs[tabKey].selected"
                (click)="selectNavItem(tabKey)"
              >
                {{ tabs[tabKey].name }}
              </button>
            </ng-container>
          </div>

          <!-- info tab -->
          <div *ngIf="tabs['info'].selected" fxLayout="column" fxLayoutGap="30px">
            <!-- Company Information -->
            <div
              class="infoblock"
              fxLayout="column"
              fxLayoutGap="10px"
              *ngIf="typeService.profileObjectFilled(displayStructure['info']['general_info'])"
            >
              <app-about-block-header [title]="'Info'"></app-about-block-header>

              <!-- branche -->
              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="15" class="label">Branche:</div>

                <div *ngIf="cp.type == 'OTHER'" class="label">
                  {{ cp.type_sector | translate }}
                </div>
                <div *ngIf="cp.type == 'CARPENTER'" class="label">Zimmerer</div>
                <div *ngIf="cp.type == 'CARPENTER_PLUS'" class="label">Zimmerer</div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.information_products">
                <div fxFlex="15" class="label">Produkte/Services:</div>
                <div class="label">
                  {{ cp.information_products }}
                </div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.information_year_of_founding">
                <div fxFlex="15" class="label">Gründungsjahr:</div>
                <div class="label">
                  {{ cp.information_year_of_founding }}
                </div>
              </div>
            </div>

            <!-- information_about_us -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="cp.information_about_us">
              <app-about-block-header [title]="'Über uns'"> </app-about-block-header>

              <div>
                <div class="label multi_line_text">
                  {{ cp.information_about_us }}
                </div>
              </div>
            </div>

            <!-- information_news -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="cp.information_news">
              <app-about-block-header [title]="'Aktuelles'"> </app-about-block-header>

              <div>
                <div class="label multi_line_text">
                  {{ cp.information_news }}
                </div>
              </div>
            </div>
          </div>

          <!-- posts tab -->
          <div *ngIf="tabs['posts'].selected && cp.posts" fxLayout="column" fxLayoutGap="30px">
            <div class="posts-container">
              <ng-container *ngFor="let post of cp.posts" [ngSwitch]="post.type">
                <ng-container *ngSwitchCase="'blog'">
                  <blog-card [entity]="$any(post).data" data-entitytype="Blog" data-id="{{ post.data.id }}"></blog-card>
                </ng-container>

                <ng-container *ngSwitchCase="'advert'">
                  <advert-grid-item
                    [entity]="$any(post).data"
                    data-entitytype="Advert"
                    data-id="{{ post.data.id }}"
                  ></advert-grid-item>
                </ng-container>

                <ng-container *ngSwitchCase="'job'">
                  <job-card [entity]="$any(post).data" data-entitytype="Job" data-id="{{ post.data.id }}"></job-card>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <!-- references tab -->
          <div *ngIf="tabs['references'].selected" fxLayout="column" fxLayoutGap="30px">
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="cp.service_products">
              <app-about-block-header [title]="'Produkte / Servicebeschreibung'"></app-about-block-header>

              <div fxLayout="row">
                <div [innerHTML]="cp.service_products"></div>
              </div>
            </div>

            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="cp.productImagesGallery.length > 0">
              <app-about-block-header [title]="'Produkte / Referenzen'"> </app-about-block-header>

              <app-swiper [galleryImages]="cp.productImagesGallery"></app-swiper>
            </div>

            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="cp.certifacteImagesGallery.length > 0">
              <app-about-block-header [title]="'Zertifikate / Team'"> </app-about-block-header>

              <div>
                <app-swiper [galleryImages]="cp.certifacteImagesGallery"></app-swiper>
              </div>
            </div>
          </div>

          <!-- contactpersons tab -->
          <div *ngIf="tabs['contactpersons'].selected" fxLayout="column" fxLayoutGap="30px">
            <!-- contact partners -->
            <div
              class="infoblock"
              fxLayout="column"
              fxLayoutGap="10px"
              *ngIf="typeService.profileObjectFilled(displayStructure['contactpersons']['contactpersons'])"
            >
              <app-about-block-header [title]="'Ansprechpartner'"></app-about-block-header>

              <div fxLayout="column" fxLayoutGap="15px">
                <div *ngFor="let c of cp.contactpersons" fxLayout="column" fxLayoutGap="5px">
                  <div fxLayout="row" *ngIf="c.area">
                    <div fxFlex="20" class="label">Bereich:</div>
                    <div class="label">{{ c.area }}</div>
                  </div>

                  <div fxLayout="row" *ngIf="c.firstname">
                    <div fxFlex="20" class="label">Vorname:</div>
                    <div class="label">
                      {{ c.firstname }}
                    </div>
                  </div>

                  <div fxLayout="row" *ngIf="c.lastname">
                    <div fxFlex="20" class="label">Nachname:</div>
                    <div class="label">
                      {{ c.lastname }}
                    </div>
                  </div>

                  <div fxLayout="row" *ngIf="c.tel">
                    <div fxFlex="20" class="label">Telefon:</div>
                    <div class="label">{{ c.tel }}</div>
                  </div>

                  <div fxLayout="row" *ngIf="c.email">
                    <div fxFlex="20" class="label">E-Mail:</div>
                    <div class="label">{{ c.email }}</div>
                  </div>

                  <!-- line -->
                  <div fxFlex="grow" style="border-top: 1px solid lightgray"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- contact tab -->
          <div *ngIf="tabs['contact'].selected" fxLayout="column" fxLayoutGap="30px">
            <!-- contact -->
            <div
              class="infoblock"
              fxLayout="column"
              fxLayoutGap="10px"
              *ngIf="typeService.profileObjectFilled(displayStructure['contact']['contact'])"
            >
              <app-about-block-header [title]="'Kontakt'"></app-about-block-header>

              <!-- contact name -->
              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.contact_name">
                <div fxFlex="15" class="label">Ansprechpartner:</div>
                <div class="label">
                  {{ cp.contact_name }}
                </div>
              </div>

              <!-- contact position -->
              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.contact_position">
                <div fxFlex="15" class="label">Position:</div>
                <div class="label">
                  {{ cp.contact_position }}
                </div>
              </div>

              <!-- phone -->
              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.telephone">
                <div fxFlex="15" class="label">Telefon:</div>
                <div class="label">
                  {{ cp.telephone }}
                </div>
              </div>

              <!-- email -->
              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.email">
                <div fxFlex="15" class="label">E-Mail:</div>
                <div class="label">
                  <a [href]="'mailto:' + cp.email">{{ cp.email }}</a>
                </div>
              </div>

              <!-- website -->
              <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="cp.website">
                <div fxFlex="15" class="label">Webseite:</div>
                <div class="label">
                  <a
                    [href]="cp.website"
                    target="_blank"
                    style="color: black; text-decoration: underline; word-break: break-word"
                    >{{ cp.website }}</a
                  >
                </div>
              </div>
            </div>

            <!-- address -->
            <div
              class="infoblock"
              fxLayout="column"
              fxLayoutGap="10px"
              *ngIf="typeService.profileObjectFilled(displayStructure['contact']['address'])"
            >
              <app-about-block-header [title]="'Unternehmensadresse'"> </app-about-block-header>

              <div *ngIf="!tabs['contact'].edit" style="padding: 10px 0">
                <div *ngIf="cp.name">
                  {{ cp.name }}
                </div>
                <div *ngIf="cp.street || cp.street_additional">{{ cp.street }} {{ cp.street_additional }}</div>
                <div *ngIf="cp.zip || cp.city">{{ cp.zip }} {{ cp.city }}</div>
                <div *ngIf="cp.state">
                  {{ cp.state }}
                </div>
                <div *ngIf="cp.country">
                  {{ cp.country }}
                </div>
                <div *ngIf="cp.impressum">
                  <a
                    [href]="cp.impressum"
                    target="_blank"
                    style="color: black; text-decoration: underline; word-break: break-word"
                    >Impressum</a
                  >
                </div>
              </div>
            </div>

            <!-- opening hours -->
            <div
              class="infoblock"
              fxLayout="column"
              fxLayoutGap="10px"
              *ngIf="cp.information_opening_hours && cp.information_opening_hours != ''"
            >
              <app-about-block-header [title]="'Öffnungszeiten'"> </app-about-block-header>

              <div *ngIf="cp.information_opening_hours">
                <div class="label" style="white-space: pre-wrap">
                  {{ cp.information_opening_hours }}
                </div>
              </div>
            </div>
          </div>

          <!-- socialmedia tab -->
          <div *ngIf="tabs['socialMedia'].selected" fxLayout="column" fxLayoutGap="30px">
            <!-- socialmedia -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
              <app-about-block-header [title]="'socialMedia'"></app-about-block-header>

              <div>
                <ng-container *ngFor="let key of socialMediaKeys">
                  <a
                    *ngIf="cp[key]"
                    class="socialmediarow"
                    [style.display]="cp[key] ? 'flex' : 'none'"
                    [href]="cp[key]"
                    target="_blank"
                    fxLayout="row"
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                    fxLayoutGap="10px"
                    style="padding-left: 10px"
                  >
                    <div class="label">
                      <i style="font-size: 40px" [class]="socialMedia[key].icon"></i>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                      Finde uns auf
                      {{ socialMedia[key].name }}
                    </div>
                  </a>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
